

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Navbar from '../components/Navbar';
import './Marketplace.scss';
import { fetchCommunities, setSelectedCategory } from '../store/slices/communitySlice';
import { getCourses, getRecommended, getTrending } from '../api/marketplace';


const Marketplace = () => {
  const dispatch = useDispatch();
  const { communities, loading, error, filters, categories = [] } = useSelector((state) => state.community);
  const [localCategories, setLocalCategories] = useState([{ _id: '', name: 'All Communities', icon: '🌐' }]);
  const [courses, setCourses] = useState([]);
  const [recommended, setRecommended] = useState([]);
  const [trending, setTrending] = useState([]);
  const [mentorTab, setMentorTab] = useState('courses');
  // Fetch top mentor data
  useEffect(() => {
    getCourses().then(data => setCourses(data?.data || [])).catch(() => setCourses([]));
    getRecommended().then(data => setRecommended(data?.data || [])).catch(() => setRecommended([]));
    getTrending().then(data => setTrending(data?.data || [])).catch(() => setTrending([]));
  }, []);

  // Fetch categories from API (same as Communities page)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch('https://yoospeak.app:5000/categories');
        const data = await res.json();
        if (data && data.data) {
          const apiCategories = data.data.map(cat => {
            const match = cat.name.match(/(.+?)([\u{1F300}-\u{1FAFF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}])?$/u);
            return {
              _id: cat._id,
              name: match ? match[1].trim() : cat.name,
              icon: match && match[2] ? match[2] : '',
            };
          });
          setLocalCategories([{ _id: '', name: 'All Communities', icon: '🌐' }, ...apiCategories]);
        }
      } catch (err) {
        setLocalCategories([{ _id: '', name: 'All Communities', icon: '🌐' }]);
      }
    };
    fetchCategories();
  }, []);

  // Fetch communities when category changes
  useEffect(() => {
    dispatch(fetchCommunities({ category: filters.selectedCategory }));
  }, [dispatch, filters.selectedCategory]);

  const handleCategoryClick = (categoryId) => {
    dispatch(setSelectedCategory(categoryId));
  };

  return (
    <div className="marketplace-page">
      <Navbar />
      {/* Hero Section */}
      <section className="marketplace-hero">
        <h1>Start selling sessions on Yoospeak</h1>
        <p>Find the best mentors, courses, and sessions for your needs.</p>
      </section>
      {/* Top Mentors Section */}
      <section className="marketplace-top-mentors">
        <h2>Top Mentors</h2>
        <div className="mentor-tabs" style={{ display: 'flex', gap: 16, justifyContent: 'center', marginBottom: 16 }}>
          <button className={mentorTab === 'courses' ? 'active' : ''} onClick={() => setMentorTab('courses')}>Courses</button>
          <button className={mentorTab === 'recommended' ? 'active' : ''} onClick={() => setMentorTab('recommended')}>Recommended</button>
          <button className={mentorTab === 'trending' ? 'active' : ''} onClick={() => setMentorTab('trending')}>Trending</button>
        </div>
        <div className="mentors-list">
          {(mentorTab === 'courses' ? courses : mentorTab === 'recommended' ? recommended : trending).slice(0, 5).map((item, i) => (
            <div className="mentor-card" key={item._id || i}>
              <img src={item.image || `/assets/mentor${i+1}.jpg`} alt={item.name || item.title || `Mentor ${i+1}`} />
              <div className="mentor-name">{item.name || item.title || `Mentor ${i+1}`}</div>
              {item.description && <div className="mentor-desc">{item.description.substring(0, 60)}{item.description.length > 60 ? '...' : ''}</div>}
            </div>
          ))}
        </div>
      </section>
      {/* Main Content Section */}
      <section className="marketplace-main">
        <aside className="marketplace-sidebar">
          <h3>Categories</h3>
          <ul className="category-list">
            {localCategories.map(cat => (
              <li
                key={cat._id}
                className={filters.selectedCategory === cat._id ? 'active' : ''}
                style={{ cursor: 'pointer', padding: '0.5rem 0' }}
                onClick={() => handleCategoryClick(cat._id)}
              >
                <span style={{ marginRight: 8 }}>{cat.icon}</span>
                {cat.name}
              </li>
            ))}
          </ul>
        </aside>
        <div className="marketplace-listings">
          {loading ? (
            <div className="text-center py-5">Loading...</div>
          ) : error ? (
            <div className="alert alert-danger">{error}</div>
          ) : communities.length === 0 ? (
            <div className="text-center py-5">No communities found.</div>
          ) : (
            communities.map((community) => (
              <div className="listing-card" key={community._id}>
                <img
                  src={community.image || 'https://via.placeholder.com/400x250/6366f1/ffffff?text=Community'}
                  alt={community.name}
                />
                <div className="listing-title">{community.name}</div>
                <div className="listing-meta">
                  {community.members || 0} members
                  {community.price > 0 ? ` • $${community.price}/mo` : ' • Free'}
                </div>
                <div className="listing-description">
                  {community.description?.substring(0, 80)}{community.description?.length > 80 ? '...' : ''}
                </div>
              </div>
            ))
          )}
        </div>
      </section>
      <footer className="marketplace-footer">
        <div>© 2026 Yoospeak. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default Marketplace;
